document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGalerias();
  initVariantes();
  initFaq();
  initMarquesina();
  initComparadorSlider();
});

function initReveal() {
  var els = document.querySelectorAll('.lm-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // elements are visible by default — nothing to do
  }
  var reveal = function (el) {
    el.style.opacity = '';
    el.style.transform = '';
  };
  var hide = function (el) {
    el.style.opacity = '0';
    el.style.transform = el.classList.contains('lm-reveal--scale') ? 'translateY(20px) scale(0.96)' : 'translateY(28px)';
  };
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-delay') || 0;
        setTimeout(function () { reveal(entry.target); }, Number(delay));
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  els.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    var alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (alreadyVisible) return; // leave it visible, no need to animate on load
    hide(el);
    io.observe(el);
    // Safety net: guarantee the element becomes visible even if the observer
    // never reports it (browser quirks, etc.). Long delay so it never fires
    // before a normally-scrolling visitor would have reached the element.
    setTimeout(function () { reveal(el); io.unobserve(el); }, 15000);
  });
}

function initGalerias() {
  document.querySelectorAll('[data-lm-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-lm-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-lm-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (!src) return;
        main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-lm-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-lm-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-lm-precio]');
    var compareEl = form.querySelector('[data-lm-precio-comparado]');
    var addBtn = form.querySelector('[data-lm-add-btn]');
    var selects = form.querySelectorAll('[data-lm-opcion]');

    function moneda(cents) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    function actualizar() {
      var seleccion = [];
      selects.forEach(function (s) { seleccion.push(s.value); });
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = moneda(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = moneda(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-text-disponible') || addBtn.textContent;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-text-agotado') || 'Sold out';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initFaq() {
  document.querySelectorAll('[data-lm-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-lm-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('is-open');
      item.closest('[data-lm-faq]').querySelectorAll('[data-lm-faq-item]').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!abierto) item.classList.add('is-open');
    });
  });
}

function initMarquesina() {
  document.querySelectorAll('[data-lm-marquesina]').forEach(function (track) {
    if (track.getAttribute('data-cloned')) return;
    track.innerHTML += track.innerHTML;
    track.setAttribute('data-cloned', 'true');
  });
}

function initComparadorSlider() {
  document.querySelectorAll('[data-lm-comparador]').forEach(function (wrap) {
    var handle = wrap.querySelector('[data-lm-comparador-handle]');
    var after = wrap.querySelector('[data-lm-comparador-after]');
    if (!handle || !after) return;

    function set(pct) {
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    set(50);

    var dragging = false;
    function pos(e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      set((x / rect.width) * 100);
    }
    handle.addEventListener('mousedown', function () { dragging = true; });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) { if (dragging) pos(e); });
    handle.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('touchmove', function (e) { if (dragging) pos(e); }, { passive: true });
  });
}
